import { Layout } from 'antd';
import SectionStyled from './styles';

const { Content } = Layout;

export const Term = () => (
  <SectionStyled>
    <Layout>
      <Content style={{ padding: '0 50px', marginTop: 64 }}>
        下記を参照 <br />
        <a href="https://www.kentaku.co.jp/corporate/outline/privacypolicy.html">
          https://www.kentaku.co.jp/corporate/outline/privacypolicy.html
        </a>
      </Content>
    </Layout>
  </SectionStyled>
);
export default Term;
